<template>
  <div class="invite-placement-test" style="padding:16px;">
    <Loading v-if="myPlacementTests.loading" />
    <div
      class="placementTestRow"
      v-else
      v-for="{ id, name } in myPlacementTests.data.results"
      :key="id"
      @click="startTest(id)"
    >
      {{ name }}
      <button class="btn">
        {{ $t("Start") }}
      </button>
    </div>
    <div
      v-if="
        !myPlacementTests.loading && myPlacementTests.data.results.length == 0
      "
    >
      <h2 class="center-me">
        {{ $t("You currently don't have any placement tests to do") }}
      </h2>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Loading from "@/components/Loading";
export default {
  name: "PlacementTestListing",
  components: { Loading },
  computed: {
    ...mapState("placementTest", ["myPlacementTests"])
  },
  methods: {
    ...mapActions("placementTest", ["getMyPlacementTests"]),
    startTest(id) {
      this.$emit("handleStartTest", id);
    }
  },
  created() {
    this.getMyPlacementTests();
  }
};
</script>

<style lang="scss">
.invite-placement-test {
  .placementTestRow {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    padding: 20px;
    align-items: center;
  }
}
</style>
